import React from "react";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/averageNumberOfVisitsPerClientSagas";

const options = [
  { id: "total", name: "Total" },
  { id: "class", name: "Class" },
  { id: "service", name: "Service" }
];

const AverageBreakdown = () => {
  const dispatch = useDispatch();

  const { average_breakdown } = useSelector(
    (state) => state.averageNumberOfVisitsPerClient.selectedFilters
  );

  return (
    <div className="average-breakdown">
      <div className="average-breakdown__title">Average Breakdown</div>
      <div className="average-breakdown__dropdown">
        <MultiSelectDropdown
          options={options}
          selectedFilters={average_breakdown}
          numberDisplayed={1}
          onSelectChange={(data) => dispatch(actionCreators.updateAverageBreakdown(data))}
        />
      </div>
    </div>
  );
};

export default AverageBreakdown;
